module.exports = __webpack_public_path__ + "static/media/alanna.7f847ca6.jpg";